import { en } from "./en";
import { es } from "./es";
import { th } from "./th";
import type { Translations } from "../types";

export const translations: Translations = {
  en,
  es,
  th,
};
